import React from "react";
import EventCard from "./EventCard";

const EventCards = ({ events, handleEventClick, isAscending = true }) => {
  const groupedEvents = groupEventsByMonthAndSpecificDate(events);

  const sortOrder = isAscending ? -1 : 1;

  return (
    <div>
      {/* Sort the months based on the chosen order */}
      {Object.keys(groupedEvents)
        .sort((a, b) => sortOrder * (new Date(`${b} 1`) - new Date(`${a} 1`))) // Sorting months
        .map((month) => (
          <div key={month}>
            <h1>{month}</h1> {/* Month Heading */}
            {/* Sort specific dates based on the chosen order */}
            {Object.keys(groupedEvents[month])
              .sort((a, b) => sortOrder * (new Date(b) - new Date(a))) // Sorting dates
              .map((specificDate) => (
                <div key={specificDate}>
                  <h2>
                    {new Date(specificDate).toLocaleDateString("en-US", {
                      weekday: "long",
                      day: "numeric",
                      month: "long",
                      year: "numeric"
                    })}
                  </h2>{" "}
                  {/* Specific Date Heading */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      padding: "20px"
                    }}
                  >
                    {/* Sort events based on the chosen order */}
                    {groupedEvents[month][specificDate]
                      .sort(
                        (a, b) =>
                          sortOrder *
                          (new Date(b.dateAndHour) - new Date(a.dateAndHour))
                      ) // Sorting events
                      .map((event) => (
                        <EventCard
                          key={event._id}
                          event={event}
                          onClick={() => handleEventClick(event._id)}
                        />
                      ))}
                  </div>
                </div>
              ))}
          </div>
        ))}
    </div>
  );
};

const groupEventsByMonthAndSpecificDate = (events) => {
  const groupedEvents = {};

  events.forEach((event) => {
    const eventDate = new Date(event.dateAndHour);
    const month = eventDate.toLocaleString("default", {
      month: "long",
      year: "numeric"
    });
    const fullDate = eventDate.toISOString().split("T")[0]; // Use ISO string for sorting

    if (!groupedEvents[month]) {
      groupedEvents[month] = {};
    }

    if (!groupedEvents[month][fullDate]) {
      groupedEvents[month][fullDate] = [];
    }

    groupedEvents[month][fullDate].push(event);
  });

  return groupedEvents;
};

export default EventCards;
